import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllDiscountCodes extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterDiscountCodes/GetAll");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateNewDiscountCode extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterDiscountCodes/CreateMasterDiscountCode");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetASingleDiscountCode extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterDiscountCodes/GetByIdMasterDiscountCode");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateASingleDiscountCode extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterDiscountCodes/UpdateMasterDiscountCode");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllDiscountCodes,
  CreateNewDiscountCode,
  GetASingleDiscountCode,
  UpdateASingleDiscountCode,
};
